export default __webpack_public_path__ + "static/media/hero-bcg2.f8dd9888.jpg";